module.exports = __webpack_public_path__ + "media/images/client/RentSearchApplication/hand-pic-80a734e2a3a0dab78fc571ec67e6222c.svg";